import React from "react";
import CountUp from "react-countup";

const formatValue = (value, format, currencyCode) => {
  const numeric = Number(value);
  const safe = Number.isFinite(numeric) ? numeric : 0;

  if (format === "currency") {
    if (currencyCode && currencyCode.length === 3 && currencyCode !== "N/A") {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        maximumFractionDigits: 0,
      }).format(Math.round(safe));
    }

    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(Math.round(safe));
  }

  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(safe);
};

const StatBlock = ({ label, value, format = "number", currencyCode, isLoading }) => {
  const numericValue = Number(value);
  const displayValue = Number.isFinite(numericValue) ? numericValue : 0;

  return (
    <div className="dash-stat">
      {isLoading ? (
        <div className="dash-stat__skeleton" aria-hidden="true" />
      ) : (
        <p className="dash-stat__value">
          {format === "number" ? (
            <CountUp end={displayValue} duration={0.7} separator="," />
          ) : (
            formatValue(displayValue, format, currencyCode)
          )}
        </p>
      )}
      <p className="dash-stat__label">{label}</p>
    </div>
  );
};

export default StatBlock;
